interface LogoProps {
  className?: string
}

/**
 * Quantizant brand mark. Uses `currentColor` so it inherits the surrounding
 * text color (e.g. `text-primary`); size follows font-size (`text-xl`, etc.).
 */
export default function Logo({ className = '' }: LogoProps) {
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M16 2L28 9V23L16 30L4 23V9L16 2Z" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <path d="M16 7L23 11V19L16 23L9 19V11L16 7Z" fill="currentColor" fillOpacity="0.12" />
      <circle cx="16" cy="15" r="3" fill="currentColor" />
      <path d="M19 18L22 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}
